const isMedia = query => query.indexOf('@media') === 0;
const isPseudo = query => query.indexOf(':') === 0;
const isMediaOrPseudo = query => isMedia(query) || isPseudo(query);
const deepClone = obj => JSON.parse(JSON.stringify(obj));
const createCssRule = (query, stringHash, css) => {
  let rule;
  const dataMediaSelector = `[data-media~="${stringHash}"]`;
  if (isMedia(query)) {
    rule = `${query} {${dataMediaSelector} ${css}}`;
  } else {
    rule = `${dataMediaSelector}${query} ${css}`;
  }
  return rule;
};

/**
 * Sanitizes the style object by converting any functions to their string representation.
 *
 * @param {Object} style - The style object to sanitize.
 * @returns {Object} - The sanitized style object.
 */
const sanitizeStyle = style => {
  const sanitizedStyle = {
    ...style
  };
  Object.keys(sanitizedStyle).forEach(property => {
    if (typeof sanitizedStyle[property] === 'function') {
      sanitizedStyle[property] = sanitizedStyle[property].toString();
    }
  });
  return sanitizedStyle;
};
export { isMedia, isPseudo, isMediaOrPseudo, deepClone, createCssRule, sanitizeStyle };